import { api, multipartApi } from './networkService';

class CompanyService {
    static async fetchOne() {
        try {
            const response = await api.get(`api/user/business`);
            return response.data;
        } catch (error) {
            console.error('Fetch business error:', error);
            throw error;
        }
    }

    static async fetchOnePublic(lang) {
        try {
            const response = await api.get(`api/public/business?lang=${lang}`);
            return response.data;
        } catch (error) {
            console.error('Fetch business error:', error);
            throw error;
        }
    }

    static async update(business) {
        try {
            const response = await multipartApi.put(`api/user/business`, business);
            return response;
        } catch (error) {
            console.error('Update user error:', error);
            throw error;
        }
    }

    static async addImage(image) {
        try {
            const response = await multipartApi.post(`api/user/business/image`, image);
            return response;
        } catch (error) {
            console.error('Add image error:', error);
            throw error;
        }
    }

    static async deleteImage(id) {
        try {
            const response = await api.delete(`api/user/business/image/${id}`);
            return response;
        } catch (error) {
            console.error('Delete image error:', error);
            throw error;
        }
    }
}

export default CompanyService;
